import * as React from 'react';
export class ColumnSeparatorHandleRenderer extends React.PureComponent {
    render() {
        return React.createElement("div", { style: { position: 'relative', width: '100%', height: 6 } },
            React.createElement("div", { style: {
                    backgroundColor: 'black',
                    position: 'absolute',
                    cursor: 'pointer',
                    top: this.props.offset,
                    left: 0,
                    width: '100%',
                    height: '100%'
                } }));
    }
}
//# sourceMappingURL=column-separator-handle-renderer.js.map